import { RouteConfig } from "@abaco/web-common/src/app";

const routes: RouteConfig[] = [
    {
        name: "farm-registry-management",
        path: "/farm/registry",
        component: () => import("./components/FarmRegistryListTileset.vue"),
        meta: { navbarItems: [{ component: "farm-select-nav-bar-item" }] },
    },
    {
        name: "farm-registry-management-detail",
        path: "/farm/registry-detail",
        component: () => import("./components/FarmSelectedContainer.vue"),
        meta: { navbarItems: [{ component: "farm-select-nav-bar-item", props: { ["is-required"]: true } }] },
    },
    {
        name: "labor",
        path: "/farm/labor",
        component: () => import("./components/SingleTileContainer.vue"),
        props: { tileId: "involved-role-labor" },
        meta: { navbarItems: [{ component: "farm-select-nav-bar-item", props: { ["is-required"]: true } }] },
    },
    {
        name: "farm-organization",
        path: "/farm/organization",
        component: () => import("./components/FarmInvolvedContainer.vue"),
        meta: { navbarItems: [{ component: "farm-select-nav-bar-item", props: { ["is-required"]: true } }] },
        props: { apiPath: "organisation_chain" },
    },
    {
        name: "farm-supply-chain",
        path: "/farm/supply-chain",
        component: () => import("./components/FarmInvolvedContainer.vue"),
        meta: { navbarItems: [{ component: "farm-select-nav-bar-item", props: { ["is-required"]: true } }] },
        props: { apiPath: "supply_chain" },
    },
    {
        name: "documents-mockup-home",
        path: `/farm/documents-mockup-home`,
        component: () => import("./components/tiles/documents/DocumentsMockTileContainer.vue"),
        meta: { navbarItems: ["farm-select-nav-bar-item"] },
    },
];

export default routes;
